export default __webpack_public_path__ + "static/O0275-120c965e5025a8d5c1c823482632b3ca.png";